<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.3829 52.0113L22.0533 107.551C21.4106 114.226 26.6611 120 33.365 120H94.1259C100.83 120 106.08 114.226 105.438 107.551L100.108 52.0014C99.5445 46.1676 94.65 41.718 88.7964 41.718H38.6946C32.841 41.718 27.9366 46.1676 27.3829 52.0014V52.0113Z"
    />
    <path
      d="M82.7252 70.4023C80.0752 70.4023 77.9296 68.2566 77.9296 65.6066V31.7704C77.9296 23.9491 71.5717 17.5912 63.7504 17.5912C55.9291 17.5912 49.5712 23.9491 49.5712 31.7704V65.6066C49.5712 68.2566 47.4255 70.4023 44.7756 70.4023C42.1256 70.4023 39.98 68.2566 39.98 65.6066V31.7704C39.98 18.6591 50.6391 8 63.7504 8C76.8617 8 87.5208 18.6591 87.5208 31.7704V65.6066C87.5208 68.2566 85.3751 70.4023 82.7252 70.4023Z"
      fill="#CB80DE"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Store'
  }
</script>
